import type {Mapper} from 'framework';
import type {NutritionPlan} from '../../domain/nutrition-plan';
import type {NutritionPlanDto} from '../dto/nutrition-plan.dto';

/**
 * Maps the trusted RPC DTO into the feature domain aggregate.
 * In-repo RPC responses are trusted; no runtime validation.
 */
export class NutritionPlanDtoToNutritionPlanMapper implements Mapper<NutritionPlanDto, NutritionPlan> {
  transform(dto: NutritionPlanDto): NutritionPlan {
    return {
      id: dto.id,
      name: dto.name,
      targets: {
        ...(dto.targets.kcal !== undefined && {kcal: dto.targets.kcal}),
        ...(dto.targets.proteinGrams !== undefined && {proteinGrams: dto.targets.proteinGrams}),
        ...(dto.targets.carbsGrams !== undefined && {carbsGrams: dto.targets.carbsGrams}),
        ...(dto.targets.fatGrams !== undefined && {fatGrams: dto.targets.fatGrams}),
      },
      startDate: dto.startDate,
      endDate: dto.endDate,
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
    };
  }
}
